import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\RatePlans\AiosellRatePlanMappingController::update
* @see app/Http/Controllers/Admin/RatePlans/AiosellRatePlanMappingController.php:85
* @route '/rate-plans/aiosell-mapping'
*/
export const update = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/rate-plans/aiosell-mapping',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\RatePlans\AiosellRatePlanMappingController::update
* @see app/Http/Controllers/Admin/RatePlans/AiosellRatePlanMappingController.php:85
* @route '/rate-plans/aiosell-mapping'
*/
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\RatePlans\AiosellRatePlanMappingController::update
* @see app/Http/Controllers/Admin/RatePlans/AiosellRatePlanMappingController.php:85
* @route '/rate-plans/aiosell-mapping'
*/
update.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\AiosellRatePlanMappingController::update
* @see app/Http/Controllers/Admin/RatePlans/AiosellRatePlanMappingController.php:85
* @route '/rate-plans/aiosell-mapping'
*/
const updateForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\RatePlans\AiosellRatePlanMappingController::update
* @see app/Http/Controllers/Admin/RatePlans/AiosellRatePlanMappingController.php:85
* @route '/rate-plans/aiosell-mapping'
*/
updateForm.put = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

const aiosellMapping = {
    update: Object.assign(update, update),
}

export default aiosellMapping